import { Button, withStyles } from '@material-ui/core';

const RedButton = withStyles({
  root: {
    minWidth: '30px',
    color: 'white',
    padding: '0px 10px',
    margin: 5,
    borderRadius: 20,
    fontSize: '1.3rem',
    background: '#D81F27',
    '&:hover': {
      background: '#f03a42',
    },
    '&:active': {
      background: '#f03a42',
    },
  },
  disabled: {
    background: '#C4C4C4',
  },
})(Button);

export default RedButton;
